import * as GC from '@grapecity/spread-sheets';
import { IProductSummaryResponse } from '@models/reports/current-month-summary';
import { IStableBalanceSeries } from '@models/stable-balance/stable-balance-calibration.js';

export const blobToBase64 = (blob): Promise<string> => {
  const reader = new FileReader();

  const promise = new Promise<string>((resolve, reject) => {
    reader.onloadend = () => {
      // @ts-ignore
      resolve(reader.result);
    };

    reader.onerror = () => {
      reject('Error Parsing');
    };
  });
  reader.readAsDataURL(blob);
  return promise;
};

export const insertImageInSpread = (sheetName: string, base64: string) => {
  const sheet = new GC.Spread.Sheets.Worksheet(sheetName);
  sheet.pictures.add(sheetName, base64, 20, 20, 800, 400);
  return sheet;
};

export const insertImageIntoSheet = (sheet: GC.Spread.Sheets.Worksheet, base64Image: string, rowIndex: number) => {
  sheet.pictures.add(rowIndex, base64Image.substr(20, 10), 20, 20, 800, 400);
  return sheet;
};

export const getWeightedTotalForProduct = (productId: number, productSummaries: IProductSummaryResponse[]) => {
  const productSummary = productSummaries.find(ps => ps.ProductID === productId);
  if (productSummary) {
    let total = 0;
    productSummaries.forEach(({ AvgBalance }) => {
      total += AvgBalance;
    });

    return total / productSummary.AvgBalance;
  }
};

/**
 * Removes the duplicate data from the stable balance array
 * Will only take historical data up until forecast start data
 * then takes non historical data
 */
export const filterStableBalanceSeries = (
  bal: IStableBalanceSeries,
  calibrationStartDate: Date,
  calibrationEndDate: Date,
  forecastStartDate: Date,
  forecastEndDate: Date
): boolean => {
  const balanceDate = new Date(bal.PeriodEndDate);
  if (balanceDate <= calibrationEndDate) {
    if (bal.IsHistorical && new Date(bal.PeriodEndDate) >= calibrationStartDate && new Date(bal.PeriodEndDate) <= calibrationEndDate) {
      return true;
    } else {
      return false;
    }
  } else if (balanceDate > calibrationEndDate) {
    if (!bal.IsHistorical && balanceDate >= forecastStartDate && balanceDate <= forecastEndDate) {
      return true;
    } else {
      return false;
    }
  }
};

// /**
//  * Exports a set of charts.
//  * @param {Array<Object>} charts - an array of the chart configurations to export
//  * @param {Object} exportOptions? - the export options (filetype etc.) common for all charts
//  * @returns {Promise}
//  */
// export const exportCharts = (charts, exportOptions) => {
//   // If you "steal" this funciton, change the below to require('highcharts-export-server'),
//   // and make sure that the export server is included as a dependency in your project,
//   // or that it's installed globally (not recommended for module usage).
//   const exporter = require('highcharts-export-server');
//   console.log();
//   // If exportOptions is blank, default to an empty object
//   exportOptions = exportOptions || {};

//   let promises = [];
//   let chartResults = [];

//   exporter.initPool();

//   charts.forEach((chart, i) => {
//     promises.push(
//       new Promise((resolve, reject) => {
//         // Use common option (e.g. filetype etc)
//         let exportData = Object.assign({}, exportOptions);
//         exportData.options = chart;

//         exporter.export(exportData, (err, res) => {
//           if (err) return reject(err);

//           // Add the data to chartData
//           chartResults.push(res.data);

//           resolve();
//         });
//       })
//     );
//   });

//   return Promise.all(promises)
//     .then(() => {
//       exporter.killPool();
//       return Promise.resolve(chartResults);
//     })
//     .catch(e => {
//       exporter.killPool();
//       return Promise.reject(e);
//     });
// };

////////////////////////////////////////////////////////////////////////////////

// // Export a couple of charts

// exportCharts([
//   {
//     title: {
//       text: 'Chart 1'
//     }
//   },
//   {
//     title: {
//       text: 'Chart 2'
//     }
//   }
// ]).then(charts => {
//   // Result of export is in charts, which is an array of base64 encoded files.
//   console.log('All done!');
// })
// .catch(e => {
//   console.log('Something went wrong:', e);
// });
